module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAOVBMVEUAAAD///////////////////////////////////////////////////////////////////////8KOjVvAAAAEnRSTlMAIN9An2C/EO/egFCvkHBhjzCVKRjYAAAAsUlEQVRIx+2TSw7DIAxEsU0gza9t7n/YopGqlAZi2ET98JYjPw0GYRrn49YabJPvUgOZRkC6EiQt27Jn+kGZ86gymzzc5CZDpjz8wR/j62RPJXhzgB/dLRG7aTQaMvfhaLLLKaRs5VgesBdn7uOiVDOmlnTcKbJgqvdxetWLwYy5oboY+B7VUTZuxQrDvsVtkYLHGV39xqDDrLxvTCYDRWBrS08WuFM08iqvtfy73DiHB9lmSc70FoTcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_douban.png
// module id = JTr5
// module chunks = 1